import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient, getDataTablesLanguage } from '../helpers/Helpers.js';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';

export default function TipologieBuyer() {

    DataTable.use(DT);

    const navigate = useNavigate();

    const columns = [
        { data: 'nome' },
        {
            width: '87px',
            data: 'id',
            fnCreatedCell: (nTd, data) => ReactDOM.render(<a href="!#" onClick={(ev) => { ev.preventDefault(); handleDetailsClick(data) }}>Dettagli</a>, nTd)
        }
    ];

    const options = {
        language: getDataTablesLanguage()
    };

    const [tableData, setTableData] = useState([]);  

    function handleDetailsClick(data) {
        navigate(`/tipologieaziendebuyer/${data}`);
    }

    useEffect(() => {

        const client = getWebClient();

        client.get(`/api/tipologieaziendebuyer`)
            .then(function (response) {
                setTableData(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    }, []);

    return (
        <>

            <link href="https://cdn.datatables.net/v/bs5/dt-2.1.8/datatables.min.css" rel="stylesheet"></link>

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <div className="row">
                    <div className="col">
                        <h4>Tipologie buyer</h4>
                    </div>
                    <div className="col text-end">
                        <a href="/tipologieaziendebuyer/new" style={{ position: 'relative', top: 7 }} onClick={(ev) => { ev.preventDefault(); navigate("/tipologieaziendebuyer/new") }}>Crea nuova tipologia buyer</a>
                    </div>
                </div>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>
                <DataTable data={tableData} columns={columns} options={options} className="table">
                    <thead>
                        <tr>
                            <th>Progressivo</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>

        </>
    )
}
